import React from 'react';
import SmartDialog from "../SmartDialog/SmartDialog";
import moment from 'moment';
import {TransactionStatus, TransactionStatusMap, TransactionType} from "../../common/Constants";
import CurrencyLabel from "../CurrencyLabel/CurrencyLabel";
import JsonTable from "../ReactJsonTable/ReactJsonTable";
import {Badge, Button} from "reactstrap";
import MDProgress from 'react-md-progress-bar';
import TTLProxy from "../../common/TTLAsyncProxy";
import {TractorRequestEndpoints} from "../../common/ProxyEndpoints";
import HTML from '../../common/HtmlHelpers';
import Utils from "../../common/Utils";
import PropTypes from 'prop-types';
import {CustomFilterFrame} from "../CRUDView";
import _ from 'lodash';

class TransactionCycleDialog extends React.Component{

    static propTypes = {
        onTransactionUpdate: PropTypes.func
    };

    constructor(props){
        super(props);
        this.state = TransactionCycleDialog.getInitialState();
        this.proxy = TTLProxy.getInstance();
    }

    static getInitialState(){

        return {
            isBusy: false,
            transactions: [],
            request: null
        };

    }

    /**
     * Shows transaction list
     * @param transactions
     * @param request
     */
    show(transactions,request){

        this.setState({
            ...TransactionCycleDialog.getInitialState(),
            transactions: transactions,
            request: request
        }, () => {
            this._dlg.show();
        });

    }

    static formatTransactionType(type){

        if(type & TransactionType.Charge){
            return "Receive Payment";
        }

        if(type  & TransactionType.Refund){
            return "Refund";
        }

        return "Unknown";
    }

    static transactionOperation(type){

        if(type & TransactionType.Charge){
            return<span><i className="fa fa-money"/> {TransactionCycleDialog.formatTransactionType(type)}</span>;
        }

        if(type  & TransactionType.Refund){
            return <span><i className="fa fa-recycle"/> {TransactionCycleDialog.formatTransactionType(type)}</span>;
        }

    }

    static transactionStatus(status){

        switch (status){
            case TransactionStatus.Succeeded:
                return <span><i className="fa fa-check" style={{ color: "#00c157" }}/> Successful</span>;
            case TransactionStatus.Invalid:
                return "Invalid";
            case TransactionStatus.Failed:
                return <span><i className="fa fa-close" style={{ color: "#ff1300" }}/> Failed</span>;
            case TransactionStatus.Idle:
                return <span><i className="fa fa-hourglass" style={{ color: "rgba(185,185,185,0.84)" }}/> Pending Confirmation</span>;
            case TransactionStatus.Unknown:
                return "Unknown";
        }

        return TransactionStatusMap[status];
    }

    async retryTransaction(){

        this.setState({ isBusy: true });

        try {

            const { request } = this.state;
            const response = await this.proxy.processRequest(TractorRequestEndpoints.retryLastTransaction(request.id));
            if(response.ok){

                const { message , status } = response.getPayload();

                if(status === "retry_ok"){

                    //  Toast success
                    HTML.toastSuccess(message);

                }
                else{

                    HTML.toastWarning(message);
                }


                //  toggle dialog
                this._dlg.toggle();

                //  relay event
                if(this.props.onTransactionUpdate){
                    this.props.onTransactionUpdate();
                }
            }

        }
        catch (e) {
            HTML.toastError(Utils.getResponseError(e));
        }
        finally {

            this.setState({
                isBusy: false
            });

        }

    }

    render(){

        const columns = [
            { key: "date_initiated" , label: <span><i className="fa fa-calendar"/> Start</span>, cell: (item,key) => moment(item[key]).format("DD/MM/YY hh:mm:ss") },
            { key: "date_completed" , label: <span><i className="fa fa-calendar"/> Complete</span> , cell: (item,key) => item[key] === null ?  <h6><Badge pill={true} color={"secondary"}>Not yet</Badge></h6> : moment(item[key]).format("DD/MM/YY hh:mm:ss") },
            { key: "type", label: "Type" , cell: (item,key) => TransactionCycleDialog.transactionOperation(item[key]) },
            { key: "actual_amount", label: "Amount" , cell: (item,key) => <CurrencyLabel value={item[key]}/> },
            { key: "mobile", label: "Wallet" },
            { key: "status" , label: "Status" , cell: (item,key) => TransactionCycleDialog.transactionStatus(item[key]) }
        ];

        const { transactions , isBusy, request } = this.state;
        const latestTransaction = (Array.isArray(transactions) && transactions.length > 0) ? transactions[transactions.length - 1] : null;

        const transactionSummary = (() => {

            const succeeded = (transactions || []).filter(x => x.status === TransactionStatus.Succeeded);

            let result = {
                paid: _.sumBy(succeeded.filter(x => x.type & TransactionType.Charge),'actual_amount'),
                refunded: _.sumBy(succeeded.filter(x => x.type & TransactionType.Refund),'actual_amount'),
                total: 0
            };

            result.total = result.paid - result.refunded;
            return result;

        })();

        return <SmartDialog title={"Transaction Cycles"} showCancelButton={false}  large={true} ref={r => this._dlg = r}>

            {request && transactions && transactions.length > 0 && <CustomFilterFrame>

                <div>
                    <b>Paid Amount:</b> <CurrencyLabel currency={request.txn_currency} value={transactionSummary.paid}/>
                </div>

                <div>
                    <b>Refunded Amount:</b> <CurrencyLabel currency={request.txn_currency} value={transactionSummary.refunded}/>
                </div>
                <hr/>

                <div className="p-2" style={{ backgroundColor: "rgba(0,0,0,.05)" }}>
                    <b>Total Remaining Amount:</b> <CurrencyLabel currency={request.txn_currency} value={transactionSummary.total}/>
                </div>

            </CustomFilterFrame>}

            <JsonTable rows={transactions} columns={columns} className="table table-hover table-responsive" settings={{
                noRowsMessage: "No transaction cycle(s) available."
            }}/>

            {isBusy && <MDProgress show={isBusy} overlay/>}

            {(latestTransaction && latestTransaction.status === TransactionStatus.Failed) && <React.Fragment>

                <hr/>

                <Button block color="green" onClick={async () => {

                    if(window.confirm(`Confirm retry transaction?\r\nID: ${latestTransaction.id}\r\nType: ${TransactionCycleDialog.formatTransactionType((latestTransaction.type))}\r\nAmount: ${latestTransaction.currency} ${latestTransaction.actual_amount.toLocaleString(undefined)}\r\nWallet: ${latestTransaction.mobile}`)){
                        await this.retryTransaction();
                    }

                }}><i className="fa fa-refresh"/> Retry {TransactionCycleDialog.formatTransactionType(latestTransaction.type)}</Button>

            </React.Fragment>}
        </SmartDialog>
    }
}

export default TransactionCycleDialog;




// WEBPACK FOOTER //
// ./src/components/TransactionCycleDialog/TransactionCycleDialog.js